const State = {
  loadingList: [],
  cancelCompleted: false
}

export default State
